import { createModel } from 'xstate/lib/model';

import baseEvents from 'features/Bento/libs/machines/config/baseEvents';

import { CompanyFinancialInfoQuery } from '../graphql/queries/companyFinancialInfo.gql';
import { FinancialInfoPayload } from '../pages/FinancialInfo/FinancialInfo';

type CompanyInfoModuleData = {
  companyFinancialInfoData: CompanyFinancialInfoQuery;
};

const context = {
  getModuleData: (() => {
    throw new Error('NOT_IMPLEMENTED');
  }) as () => CompanyInfoModuleData,
  shouldReviewFinancialInfo: false,
};

export type Context = typeof context;

const model = createModel(context, {
  events: {
    ...baseEvents,
    EDIT_FINANCIAL_INFO: () => ({}),
    SAVE_FINANCIAL_INFO: (data: FinancialInfoPayload) => ({ data }),
  },
});

export type Model = typeof model;

export default model;
